import React from "react";
import CloseIcon from "../VectorIcons/CloseIcon";
import InfoIcon from "../VectorIcons/InfoIcon";
import "./style/AlertBox.scss";

const AlertBox = (props) => {
  const { hasCloseIcon = true, closed, type, text, color, children } = props;

  return (
    <>
      <div className={`alertBox ${type}`} id="alertBox">
        {hasCloseIcon && (
          <div className="closedBox" onClick={() => closed()}>
            <CloseIcon size={16} color={color ? color : "#795800"} />
          </div>
        )}

        <InfoIcon color={color ? color : "#795800"} size={24} />
        <p>{text}</p>

        {!!children && children}
      </div>
    </>
  );
};

export default AlertBox;
